<template>
  <div class="privacy-container">
    <anchor class="privacy-navigator">
      <anchor-link href="#section1" title="1. 我们如何收集和使用您的个人信息" />
      <anchor-link href="#section2" title="2. 我们如何使用 Cookie 和同类技术" />
      <anchor-link href="#section3" title="3. 我们如何共享、转让、公开披露您的个人信息" />
      <anchor-link href="#section4" title="4. 我们如何保护您的个人信息" />
      <anchor-link href="#section5" title="5. 您的权利" />
      <anchor-link href="#section6" title="6. 我们如何处理儿童的个人信息" />
      <anchor-link href="#section7" title="7. 您的个人信息如何在全球范围转移" />
      <anchor-link href="#section8" title="8. 本政策如何更新" />
      <anchor-link href="#section9" title="9. 如何联系我们" />
    </anchor>

    <privacy-content></privacy-content>
  </div>
</template>


<script>
import anchor from "./components/anchor.vue";
import anchorLink from "./components/anchorLink.vue";
import privacyContent from "./components/privacyContent.vue";

export default {
  components: {
    anchor,
    anchorLink,
    privacyContent
  },
  data() {
    return {
      container: () => document.querySelector("body")
    };
  }
};
</script>

<style lang="scss" scoped>
@import "./styles/privacy.scss";
</style>



// WEBPACK FOOTER //
// src/views/privacy/privacy.vue